import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './../core/authservice/auth.service';

@Component({
    selector: 'app-redirect',
    template: ``,
    standalone: false
})
export class RedirectComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    if (this.router.url !== '/') {
      return;
    }
    // Remove 'splash-screen-hidden' class from <body>
    this.renderer.removeClass(document.body, 'splash-screen-hidden');
    const currentUrl = this.router.url;
    let targetRoute = '';
    
    if (currentUrl.includes('home')) {
      // If the URL already contains '/home', we keep it.
      targetRoute = currentUrl;
    } else {
      const currentUser = this.authService.currentUserValue;
      if (currentUser) {
        switch (currentUser.role) {
          case 'SuperAdmin':
            targetRoute = '/superadmin/institutions';
            break;
          case 'Admin':
            targetRoute = '/admin/users';
            break;
          case 'Teacher':
            targetRoute = '/profile/profile-setting';
            break;
          default:
            targetRoute = '/profile/profile-setting';
        }
      } else {
       targetRoute = '/auth/login';
      }
    }

    // Navigate to the target route
    this.router.navigate([targetRoute]).then(() => {
      // Add 'splash-screen-hidden' class back to <body> after navigation completes
      this.renderer.addClass(document.body, 'splash-screen-hidden');
    });
  }
  
}